module.exports = __webpack_public_path__ + "static/media/code-1.d5866a19.svg";